import React from 'react';
import PropTypes from 'prop-types';

// Shared UI Library Components
import { CardElement, CustomIconBig, SpinElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './auth-layout.scss';

type Props = {
  cardTitle: string;
  cardCurrentStep?: string;
  cardTotalSteps?: string;
  isLoading?: boolean;
  rightBarIcon: string;
  children: React.ReactNode;
};

export const AuthLayout = ({
  cardTitle,
  cardCurrentStep,
  cardTotalSteps,
  isLoading = false,
  rightBarIcon,
  children
}: Props) => {
  return (
    <div className="auth-inside">
      { isLoading && <div className={ 'auth-spinner' }><SpinElement fullHeight={ true }/></div> }
      { !isLoading && <div className="auth-inside-item left-section">
        <div className="forms-section">
          <img className={ 'logo' } src={ '/assets/images/logo.svg' } alt={ '' }/>
          { !isLoading && <CardElement
            cardTitle={ cardTitle }
            cardCurrentStep={ cardCurrentStep }
            cardTotalSteps={ cardTotalSteps }
            mobileAutoWidth={ true }
            mobileChangeBg={ true }
            titleCentered={ true }
            mobileImageSubtitle={ <img className={ 'card-logo' } src={ '/assets/icons/big/auth.svg' } alt={ '' }/> }
          >
            { children }
          </CardElement> }
        </div>
      </div> }
      { !isLoading && <div className="auth-inside-item right-section">
        <CustomIconBig name={ rightBarIcon }/>
      </div> }
    </div>);
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired
};
